import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms'; // Pour ngModel dans le modal
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-croud-user',
    templateUrl: './croud-user.component.html',
    styleUrls: ['./croud-user.component.scss'],

})
export class CroudUserComponent implements OnInit {
    @ViewChild('modalCategory') modalTemplate!: TemplateRef<any>;
    @ViewChild('ajouterEntreprise') ajouterEntreprise!: TemplateRef<any>;

    private modalRef!: NgbModalRef;
    isAddCardActive: boolean = false;
    isEditing: boolean = false;
    editingEntrepriseIndex: number | null = null;
    userForm: FormGroup;
    entrepriseForm: FormGroup;
    selectAll: boolean = true;
    selectedCategory: any = null;
    selectedCategoryIndex: number | null = null;
    selectedEntrepriseIndex: number | null = null;
    hoveredEntrepriseIndex: number | null = null;

    entreprisesAjoutees: any[] = [];
    selectedEntreprise: number | null = null;
    entreprises = [
        { id: 0, nom: 'Shopi', logo: 'assets/images/logo/logo.png' },
        { id: 1, nom: 'Shopi Pro', logo: 'assets/images/logo/logo.png' },
        { id: 2, nom: 'Shopi Enterprise', logo: 'assets/images/logo/logo.png' }
    ];

    categories = [
        { name: 'Client', enabled: true, permissions: this.getClientPermissions() },
        { name: 'Fournisseur', enabled: true, permissions: this.getFournisseurPermissions() },
        { name: 'Catalogue', enabled: true, permissions: this.getCataloguePermissions() },
        { name: 'Vente', enabled: true, permissions: this.getVentePermissions() },
        { name: 'Achat', enabled: true, permissions: this.getAchatPermissions() },
        { name: 'Inventaire', enabled: true, permissions: this.getInventairePermissions() },
        { name: 'Comptabilité', enabled: true, permissions: this.getComptabilitePermissions() },
        { name: 'Rapports', enabled: true, permissions: this.getRapportPermissions() },
        { name: 'Pièce jointe', enabled: true, permissions: this.getPieceJointePermissions() },
    ];

    constructor(
        private fb: FormBuilder,
        private modalService: NgbModal,
        private toastr: ToastrService
    ) {
        this.userForm = this.fb.group({
            prenom: ['', [Validators.required, Validators.minLength(2)]],
            nom: ['', [Validators.required, Validators.minLength(2)]],
            telephone: ['', [Validators.required, Validators.pattern(/^\+?\d{10,15}$/)]],
            email: ['', [Validators.email]],
            motDePasse: ['', [Validators.required, Validators.minLength(8)]]
        });

        this.entrepriseForm = this.fb.group({
            entrepriseId: [null, Validators.required]
        });
    }

    ngOnInit(): void {
        this.checkIfAllSelected();
        // Charger les entreprises depuis localStorage si elles existent
        this.loadEntreprisesFromStorage();
    }

    // Getters pour les contrôles du formulaire
    get prenom() { return this.userForm.get('prenom'); }
    get nom() { return this.userForm.get('nom'); }
    get telephone() { return this.userForm.get('telephone'); }
    get email() { return this.userForm.get('email'); }
    get motDePasse() { return this.userForm.get('motDePasse'); }

    private loadEntreprisesFromStorage(): void {
        const savedEntreprises = localStorage.getItem('entreprisesAjoutees');
        if (savedEntreprises) {
            try {
                this.entreprisesAjoutees = JSON.parse(savedEntreprises);
            } catch (error) {
                console.error('Erreur lors du chargement des entreprises:', error);
                this.entreprisesAjoutees = [];
            }
        }
    }

    private saveEntreprisesToStorage(): void {
        localStorage.setItem('entreprisesAjoutees', JSON.stringify(this.entreprisesAjoutees));
    }

    selectEntreprise(index: number): void {
        this.selectedEntreprise = index;
        this.entrepriseForm.patchValue({ entrepriseId: index });
        console.log('Entreprise sélectionnée:', this.entreprises[index].nom);
    }
    selectEntrepriseCard(index: number): void {
        if (this.selectedEntrepriseIndex === index) {
            // Si déjà sélectionnée, la désélectionner
            this.selectedEntrepriseIndex = null;
        } else {
            // Sélectionner cette carte
            this.selectedEntrepriseIndex = index;
        }
    }
    hoverEntreprise(index: number, isHovered: boolean): void {
        if (isHovered) {
            this.hoveredEntrepriseIndex = index;
        } else {
            this.hoveredEntrepriseIndex = null;
        }
    }

    /**
     * Met à jour l'entreprise (version améliorée)
     */
    editEntreprise(index: number): void {
        if (this.selectedEntrepriseIndex !== index) {
            // Si la carte n'est pas sélectionnée, la sélectionner d'abord
            this.selectEntrepriseCard(index);
        }

        const entreprise = this.entreprisesAjoutees[index];
        if (!entreprise) {
            this.toastr.error('Entreprise non trouvée', 'Erreur');
            return;
        }

        // Déterminer quelle entreprise prédéfinie correspond (par nom)
        const entreprisePredefinieIndex = this.entreprises.findIndex(e => e.nom === entreprise.nom);
        this.isEditing = true;
        this.editingEntrepriseIndex = index;
        this.selectedEntreprise = entreprisePredefinieIndex !== -1 ? entreprisePredefinieIndex : 0;
        this.entrepriseForm.patchValue({ entrepriseId: this.selectedEntreprise });

        const options: NgbModalOptions = {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: true,
            windowClass: 'custom-entreprise-modal'
        };

        this.modalRef = this.modalService.open(this.ajouterEntreprise, options);

        this.modalRef.result.then(
            (result) => {
                console.log('Modal édition fermé avec:', result);
                // Garder la carte sélectionnée après fermeture du modal
            },
            (reason) => {
                console.log('Modal édition fermé par:', reason);
                // Garder la carte sélectionnée même si annulé
            }
        );
    }

    /**
     * Supprime l'entreprise (version améliorée)
     */
    deleteEntreprise(index: number): void {
        if (confirm(`Êtes-vous sûr de vouloir supprimer l'entreprise "${this.entreprisesAjoutees[index].nom}" ?`)) {
            const entrepriseSupprimee = this.entreprisesAjoutees.splice(index, 1)[0];

            // Si l'entreprise supprimée était sélectionnée, désélectionner
            if (this.selectedEntrepriseIndex === index) {
                this.selectedEntrepriseIndex = null;
            } else if (this.selectedEntrepriseIndex !== null && this.selectedEntrepriseIndex > index) {
                // Ajuster l'index des cartes suivantes
                this.selectedEntrepriseIndex--;
            }

            this.saveEntreprisesToStorage();
            this.toastr.success(`Entreprise "${entrepriseSupprimee.nom}" supprimée avec succès`, 'Succès');
        }
    }

    /**
     * Soumission du formulaire d'entreprise (version améliorée)
     */
    onSubmitEntreprise(): void {
        if (this.selectedEntreprise === null) {
            this.toastr.error('Veuillez sélectionner une entreprise', 'Erreur');
            return;
        }

        const entrepriseSelectionnee = this.entreprises[this.selectedEntreprise];

        if (this.isEditing && this.editingEntrepriseIndex !== null) {
            // Mode édition
            const entrepriseActuelle = this.entreprisesAjoutees[this.editingEntrepriseIndex];

            // Vérifier si on change pour une entreprise déjà existante
            const existeDeja = this.entreprisesAjoutees.some((e, idx) =>
                e.nom === entrepriseSelectionnee.nom && idx !== this.editingEntrepriseIndex
            );

            if (existeDeja) {
                this.toastr.warning(`L'entreprise "${entrepriseSelectionnee.nom}" est déjà ajoutée`, 'Attention');
                this.closeAddEntrepriseModal();
                return;
            }

            // Mettre à jour l'entreprise
            this.entreprisesAjoutees[this.editingEntrepriseIndex] = {
                ...entrepriseActuelle,
                nom: entrepriseSelectionnee.nom,
                logo: entrepriseSelectionnee.logo,
                updatedAt: new Date().toISOString()
            };

            // Garder la carte sélectionnée après mise à jour
            this.selectedEntrepriseIndex = this.editingEntrepriseIndex;

            this.saveEntreprisesToStorage();
            this.toastr.success(`Entreprise "${entrepriseSelectionnee.nom}" mise à jour avec succès`, 'Succès');
            this.closeAddEntrepriseModal();
        } else {
            // Mode ajout
            const nouvelleEntreprise = {
                id: Date.now(),
                nom: entrepriseSelectionnee.nom,
                logo: entrepriseSelectionnee.logo,
                telephone: '',
                email: '',
                createdAt: new Date().toISOString()
            };

            // Vérifier si l'entreprise n'est pas déjà ajoutée
            const existeDeja = this.entreprisesAjoutees.some(e => e.nom === nouvelleEntreprise.nom);
            if (existeDeja) {
                this.toastr.warning(`L'entreprise "${nouvelleEntreprise.nom}" est déjà ajoutée`, 'Attention');
                this.closeAddEntrepriseModal();
                return;
            }

            this.entreprisesAjoutees.push(nouvelleEntreprise);
            this.saveEntreprisesToStorage();
            this.toastr.success(`Entreprise "${nouvelleEntreprise.nom}" ajoutée avec succès`, 'Succès');

            // Sélectionner automatiquement la nouvelle entreprise ajoutée
            this.selectedEntrepriseIndex = this.entreprisesAjoutees.length - 1;

            this.closeAddEntrepriseModal();
        }
    }

    /**
     * Ferme le modal d'entreprise (version améliorée)
     */
    closeAddEntrepriseModal(): void {
        this.modalRef?.dismiss('Cancel click');
        this.isAddCardActive = false;
        this.isEditing = false;
        this.editingEntrepriseIndex = null;
        this.selectedEntreprise = null;
        this.entrepriseForm.reset();
        // Ne pas réinitialiser selectedEntrepriseIndex pour garder la sélection
    }

    /**
     * Soumission du formulaire principal (version améliorée)
     */
    onSubmit(): void {
        if (this.userForm.valid) {
            console.log('Formulaire utilisateur soumis:', this.userForm.value);
            console.log('Entreprise sélectionnée:', this.selectedEntrepriseIndex !== null ? this.entreprisesAjoutees[this.selectedEntrepriseIndex]?.nom : 'Aucune');
            console.log('Permissions:', this.categories);
            console.log('Entreprises ajoutées:', this.entreprisesAjoutees);
            this.toastr.success('Utilisateur créé avec succès', 'Succès');
        } else {
            this.toastr.error('Veuillez remplir correctement le formulaire', 'Erreur');
        }
    }

    openAddEntrepriseModal(): void {
        this.isEditing = false;
        this.editingEntrepriseIndex = null;
        this.selectedEntreprise = null;
        this.entrepriseForm.reset();

        const options: NgbModalOptions = {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: true,
            windowClass: 'custom-entreprise-modal'
        };

        this.modalRef = this.modalService.open(this.ajouterEntreprise, options);

        this.modalRef.result.then(
            (result) => {
                console.log('Modal entreprise fermé avec:', result);
                this.isAddCardActive = false;
            },
            (reason) => {
                console.log('Modal entreprise fermé par:', reason);
                this.isAddCardActive = false;
            }
        );
    }



    goBack(): void {
        window.history.back();
    }

    toggleAllSwitches(): void {
        this.categories.forEach(item => item.enabled = this.selectAll);
    }

    checkIfAllSelected(): void {
        this.selectAll = this.categories.every(item => item.enabled);
    }

    openPopup(category: any, index: number): void {

        this.selectedCategory = { ...category };
        this.selectedCategoryIndex = index;
        const options: NgbModalOptions = {
            size: 'xl',
            centered: true,
            backdrop: 'static',
            keyboard: true,
            windowClass: 'custom-xl-modal'
        };
        this.modalRef = this.modalService.open(this.modalTemplate, options);
    }

    saveCategory(): void {
        if (this.selectedCategoryIndex !== null) {
            this.categories[this.selectedCategoryIndex] = { ...this.categories[this.selectedCategoryIndex], ...this.selectedCategory };
        }
        this.modalRef.close('Accept click');
        this.selectedCategory = null;
        this.selectedCategoryIndex = null;
        this.toastr.success('Permissions mises à jour avec succès', 'Succès');
    }

    closePopup(): void {
        this.modalRef.dismiss('Cancel click');
        this.selectedCategory = null;
        this.selectedCategoryIndex = null;
    }

    private getDefaultPermissions(): any {
        return {
            devis: { readWrite: true, read: true, cancel: true, stats: false, cancelDoc: false, seal: false },
            clientOrder: { readWrite: true, read: true, cancel: true, stats: false, cancelDoc: false, seal: false },
            deliveryNote: { readWrite: true, read: true, cancel: true, stats: true, cancelDoc: false, seal: false },
            exitNote: { readWrite: true, read: true, cancel: true, stats: false, cancelDoc: false, seal: false },
            invoice: { readWrite: true, read: true, cancel: true, stats: true, cancelDoc: true, seal: true },
            sales: { readWrite: true, read: false, cancel: false, stats: false, cancelDoc: true, seal: true }
        };
    }

    private getVentePermissions(): any {
        return {
            devis: { readWrite: true, read: true, cancel: true, stats: false, cancelDoc: false, seal: false },
            clientOrder: { readWrite: true, read: true, cancel: true, stats: false, cancelDoc: false, seal: false },
            deliveryNote: { readWrite: true, read: true, cancel: true, stats: true, cancelDoc: false, seal: false },
            exitNote: { readWrite: true, read: true, cancel: true, stats: false, cancelDoc: false, seal: false },
            invoice: { readWrite: true, read: true, cancel: true, stats: true, cancelDoc: true, seal: true },
            sales: { readWrite: true, read: true, cancel: false, stats: false, cancelDoc: true, seal: true }
        };
    }

    private getAchatPermissions(): any {
        return {
            fournisseurOrder: { readWrite: true, read: true, cancel: true, stats: false, cancelDoc: false, seal: false },
            deliveryNote: { readWrite: true, read: true, cancel: true, stats: false, cancelDoc: false, seal: false },
            invoiceFournisseur: { readWrite: true, read: true, cancel: true, stats: true, cancelDoc: false, seal: false },
            vente: { readWrite: false, read: false, cancel: false, stats: false, cancelDoc: true, seal: false },
        };
    }

    private getInventairePermissions(): any {
        return {
            inventaire: { readWrite: true, validate: true, cancelDoc: true, dashboard: true, cancel: true, read: true },
            achat: { readWrite: false, read: false, cancel: true, stats: false, cancelDoc: true, seal: false },
            transferNote: { readWrite: true, read: true, cancel: true, stats: false, cancelDoc: true, seal: true }
        };
    }

    private getComptabilitePermissions(): any {
        return {
            manageBalance: { manage: true, manageAccount: true, cancelPayment: true, deletePayment: true, manageChecks: true }
        };
    }
    private getClientPermissions(): any {
        return {
            client: { lire: true, lireEcrire: true, exporter: true}
        };
    }
    private getFournisseurPermissions(): any {
        return {
            fournisseur: { lire: true, lireEcrire: true, exporter: true}
        };
    }
    private getRapportPermissions(): any {
        return {
            rapports: { lire: true, lireEcrire: true, exporter: true, importer: true, prix: true}
        };
    }
    private getPieceJointePermissions(): any {
        return {
            pieceJointe: { lire: true, lireEcrire: true, supprimer: true, lirePropre: true, supprimerPropre: true}
        };
    }
    private getCataloguePermissions(): any {
        return {
            catalogue: { lire: true, lireEcrire: true, supprimer: true, lirePropre: true, supprimerPropre: true}
        };
    }

}
